import { createContext, useContext, useState, ReactNode } from 'react';

interface TopBarContextType {
  topBarContent: ReactNode | null;
  setTopBarContent: (content: ReactNode | null) => void;
}

const TopBarContext = createContext<TopBarContextType | undefined>(undefined);

export function TopBarProvider({ children }: { children: ReactNode }) {
  const [topBarContent, setTopBarContent] = useState<ReactNode | null>(null);

  return (
    <TopBarContext.Provider value={{ topBarContent, setTopBarContent }}>
      {children}
    </TopBarContext.Provider>
  );
}

export function useTopBar() {
  const context = useContext(TopBarContext);
  if (context === undefined) {
    throw new Error('useTopBar must be used within a TopBarProvider');
  }
  return context;
} 